import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { REQUEST_USER } from '../../../Users/constants';
import { PerformActionButton } from '../PerformActionButton';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { HBox, VBox } from '../../../../components/Box';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { List, Row } from '../../../../components/List';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import styles from './AUTOHUIS_task_1.module.css';
import { FormField } from '../../../../components/FormFields';
import { selectUser } from '../../../Users/selectors';
import { selectVehicleProperty, selectVehicle } from '../../../Vehicles/selectors';
import { Edit, Trash } from 'react-feather';
import { getPropByName } from '../../../../utils/props';
import { setVehicleProperties, setVehicleProperty } from '../../../Vehicles/actions';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const Container = styled.div``;

dayjs.extend(customParseFormat);
let todaydate = new Date().toISOString();
import { fetchUser } from '../../../Users/actions';


const STATE = {
  approve: false,
  regplate_code: '',
  isOpenAddModal: false,
  tasksRemarks: [],
  newRemarkText: '',
  editableRemark: null,
  buttonClicked: false,
};




/* eslint-disable react/prefer-stateless-function */
class AUTOHUIS_task_1Comp extends BaseCellComp { 
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vehicle?.tasksRemarks !== this.props.vehicle?.tasksRemarks) {
      try {
        const parsedTasksRemarks = JSON.parse(this.props.vehicle.tasksRemarks || '[]');
        this.setState({ tasksRemarks: parsedTasksRemarks });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
      }
    }
  }
  

  componentDidMount() {
    this.props.fetch();
    const { vehicle } = this.props;

    if (vehicle && vehicle.tasksRemarks) {
      try {
        const parsedTasksRemarks = JSON.parse(vehicle.tasksRemarks);
        this.setState({ tasksRemarks: parsedTasksRemarks || [] });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
        // Handle the error gracefully, e.g., set default state or display a message
      }
    }
  }

  reset() {
    this.setState(prevState => ({
      ...STATE,
      tasksRemarks: prevState.tasksRemarks, // Preserve tasksRemarks
    }));
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }
  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText.trim(),
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
    };
  
    const updatedTasksRemarks = [...this.state.tasksRemarks, remark];
  
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks), () => {
      this.setState({
        tasksRemarks: updatedTasksRemarks, // Update the state with the new remarks array
        newRemarkText: '', // Reset the newRemarkText
        isOpenAddModal: false, // Close the modal
        editableRemark: null, // Reset the editable remark state
      });
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      // nameTask: this.props.payload.task_name,
    };

    const tasksRemarks = this.state.tasksRemarks?.filter(remark => remark?.id != remarkId);
    const updatedtasksRemarks = [...tasksRemarks, remark];

    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedtasksRemarks), () => {
      this.setState(prevState => ({
        ...STATE,
        approve: prevState.approve,
        tasksRemarks: prevState.tasksRemarks,
      }));
      this.props.refreshBoards();
    });
  }

  onDelete = remarkId => {
    const updatedTasksRemarks = this.state.tasksRemarks.filter(remark => remark.id !== remarkId);
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks));
  };

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  getTaskStatus() {
    let name = this.props.payload?.task_name;
    return this.vehicle[name];
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }


  getStatusName() {
    let name = this.props.payload?.task_name;
    if (!name) return '';
    return this.lbl('vehicle.plannable.status.' + this.vehicle[name]);
  }


  renderAddModal() {
    return this.state.isOpenAddModal ? (
      <Modal
        className={styles.modal}
        title={
          this.state.editableRemark
            ? this.lbl('info.tasksremarks.edit')
            : this.lbl('info.tasksremarks.add')
        }
        onClose={() => this.setState({ isOpenAddModal: false })}
      >
        <FormField>
          <textarea
            className="form-control"
            value={this.state.newRemarkText}
            onChange={e => this.setState({ newRemarkText: e.target?.value })}
          />
        </FormField>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={
              this.state.editableRemark
                ? () => this.onEdit(this.state.editableRemark)
                : this.onSave.bind(this)
            }
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </Modal>
    ) : null;
  }
  
  renderRemarks() {
    const { tasksRemarks } = this.state;
  
    return tasksRemarks.map(remark => (
      <Row key={remark?.id}>
        <div className={styles.remarkCard}>
          <HBox className="gap-2" vCenter right>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              size={'btn-sm'}
              onClick={() =>
                this.setState({ isOpenAddModal: true, editableRemark: remark?.id, newRemarkText: remark?.text })
              }
            >
              <Edit />
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={() => this.onDelete(remark?.id)}>
              <Trash />
            </ButtonComponent>
          </HBox>
          <VBox className="remark" vCenter>
            {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
            <div className={styles.remarkText}>
              <h6>{remark?.text}</h6>
            </div>
          </VBox>
          <HBox>
            <div>{remark?.nameTask}</div>
            <div>{remark?.date}</div>
          </HBox>
        </div>
      </Row>
    ));
  }
  

  renderApprove() {
    if (!this.state.approve) return null;

    const vehicle = this.vehicle;
    const tasks = [
        { title: "Poetsen binnenkant", person: vehicle.wassen_poetsen_binnenkant_person, description: vehicle.wassen_poetsen_binnenkant_description },
        { title: "Poetsen Compleet", person: vehicle.poetsen_compleet_person, description: vehicle.poetsen_compleet_description },
        { title: "Poetsen Buitenkant", person: vehicle.poetsen_buitenkant_person, description: vehicle.poetsen_buitenkant_description },
        { title: "Ozon Behandeling", person: vehicle.ozon_behandeling_person, description: vehicle.ozon_behandeling_description },
        { title: "Velgen Wisselen", person: vehicle.velgen_wisselen_person, description: vehicle.velgen_wisselen_description },
        { title: "Opfrissen", person: vehicle.opfrissen_person, description: vehicle.opfrissen_description },
        { title: "Stickers Verwijderen", person: vehicle.stickers_verwijderen_person, description: vehicle.stickers_verwijderen_description },
        { title: "Aflever Klaar Maken", person: vehicle.aflever_klaar_maken_person, description: vehicle.aflever_klaar_maken_description },
      ];
    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />
        <p>Openstaande taken:</p>
          <>
          {tasks
            .filter(task => task.person === "2") // Show only tasks assigned to person "2"
            .map((task, index) => (
              <div key={index}>
                <b>{task.title}</b>
                <p>{task.description}</p>
              </div>
            ))}
        </>
       

        {this.renderAddModal(this.state.isEdit)}
                  <HBox>
                    <ButtonComponent
                      style={'ButtonSoftPrimary'}
                      size={'btn-sm'}
                      onClick={() => this.setState({ isOpenAddModal: true })}
                    >
                      {this.lbl('info.kanbantasksremarks.add')}
                    </ButtonComponent>
                  </HBox>
                  <List>{this.renderRemarks()}</List>
                  <FormField>
          <textarea
            className="form-control"
            value={this.state.newRemarkText}
            onChange={e => this.setState({ newRemarkText: e.target?.value })}
          />
        </FormField>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={
              this.state.editableRemark
                ? () => this.onEdit(this.state.editableRemark)
                : this.onSave.bind(this)
            }
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
        <Well>{this.props.column.label} Voltooid?</Well>
        <ModalControls>
          <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = { ...this.vehicle, [task_name]: this.props.taskPropertyValue };
    const tasks = [
      { title: "Poetsen binnenkant", person: vehicle.wassen_poetsen_binnenkant_person, description: vehicle.wassen_poetsen_binnenkant_description },
      { title: "Poetsen Compleet", person: vehicle.poetsen_compleet_person, description: vehicle.poetsen_compleet_description },
      { title: "Poetsen Buitenkant", person: vehicle.poetsen_buitenkant_person, description: vehicle.poetsen_buitenkant_description },
      { title: "Ozon Behandeling", person: vehicle.ozon_behandeling_person, description: vehicle.ozon_behandeling_description },
      { title: "Velgen Wisselen", person: vehicle.velgen_wisselen_person, description: vehicle.velgen_wisselen_description },
      { title: "Opfrissen", person: vehicle.opfrissen_person, description: vehicle.opfrissen_description },
      { title: "Stickers Verwijderen", person: vehicle.stickers_verwijderen_person, description: vehicle.stickers_verwijderen_description },
      { title: "Aflever Klaar Maken", person: vehicle.aflever_klaar_maken_person, description: vehicle.aflever_klaar_maken_description },
    ];
    const task_name = this.props.payload?.task_name;
    console.log(task_name + '+++++');
    const TASK_REMARK_TYPE = task_name?.replace('task_', '');
    
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <p>Openstaande taken:</p>
          <>
            {tasks
              .filter(task => task.person === "2")
              .map((task, index) => (
                <div key={index}>
                  <b>{task.title}</b>
                  <p>{task.description}</p>
                </div>
              ))}
          </>
          
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
  
        {this.renderApprove()}
            
        {/* Move renderAddModal here to ensure it stays on top */}
        {this.renderAddModal()}
      </Cell>
    );
  }
}
AUTOHUIS_task_1Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedUser: selectUser(ownProps?.loggedUserId),
    taskPropertyValue: selectVehicleProperty(ownProps.cell.vehicle.id, ownProps.payload?.task_name),
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-tasksRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE + ownProps.vehicle?.id,
    ]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: async () => {
      // Dispatch an action to indicate the start of loading
      dispatch({ type: 'FETCH_START' });

      try {
        // Perform the fetch operation
        await dispatch(fetchUser(ownProps?.loggedUserId));
      } catch (error) {
        // Handle any errors during the fetch
        console.error('Error fetching user:', error);
      } finally {
        // Dispatch an action to indicate loading is complete
        dispatch({ type: 'FETCH_END' });
      }
    },

    assign(id, callback) {
      dispatch(
        assignVehicleTasks(ownProps.cell.vehicle.id, `${id}`, true, ownProps.payload?.task_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    

    setRemark(vehicle_id, dto, callback) {
      dispatch(setVehicleProperty(vehicle_id, 'tasksRemarks', dto, callback));
    },
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(vehicle_id, name, value) {
      dispatch(setVehicleProperty(vehicle_id, name, value));
    },
    update(vehicle_id, status, callback) {
      dispatch(
        setVehicleProperty(vehicle_id, ownProps.payload.task_name, status, result => {
          callback?.();
          ownProps.onChange();
        }),
      );
    },
    updateVehicleProperties(vehicleId, properties, callback) {
      dispatch(setVehicleProperties(vehicleId, properties, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const AUTOHUIS_task_1 = compose(
  withConnect,
  withRouter,
)(AUTOHUIS_task_1Comp);
